<template>
  <div v-if="isShowExportPopTip" class="f-pf popTip f-df f-ai f-jc">
    <div
      v-loading="isExporLoading"
      element-loading-text="正在导出中..."
      element-loading-spinner="el-icon-loading"
      class="bg-white popTip-box">
      <h3 class="f-df f-ai f-jcsb pd-column10-row15 color-dark f-fs16 bor-btm-gray">
        <span>选择要导出的信息</span>
        <i class="el-icon-close f-fs16 f-csp color-dark" @click.stop="cancle()"></i>
      </h3>
      <div class="f-df f-cl6 bor-btm-gray popTip-main-con">
        <!--导出信息的树形结构-->
        <ul
          v-for="(item, index) in exportTables"
          :key="index"
          class="bor-right-ddd flex-1 f-oxh">
          <li
            v-for="elem in item"
            :key="elem.id"
            :class="elem.isHasChild && elem.active ? 'active' : ''"
            class="pd-column10-row15 f-csp"
            @click="exportItem(elem, index)">
            <!--必选字段-->
            <el-checkbox
              v-if="index && !elem.isHasChild && elem.isRequired"
              v-model="elem.isCheckBox"
              disabled>
              {{ elem.name }}
            </el-checkbox>
            <!--没有child出现checkbox框-->
            <el-checkbox
              v-else-if="index && !elem.isHasChild && !elem.isRequired"
              v-model="elem.isCheckBox"
              @change="exportCheckChange($event, elem)">
              {{ elem.name }}
            </el-checkbox>
            <!--有child可选择的字段-->
            <p v-else class="f-df f-ai">
              <span class="flex-1">{{ elem.name }}</span>
              <i v-if="elem.isHasChild" class="el-icon-arrow-right f-fs16"></i>
            </p>
          </li>
        </ul>
        <div class="flex-1 pd-column15 yxExport-box">
          <h5 class="color-dark f-fwn pd-row15 pd-btm15">
            已选字段
            <span v-if="seletedChooseExport.length" class="blue-color">（{{ seletedChooseExport.length }}）</span>
          </h5>
          <dl class="f-oxh pd-row15">
            <dd
              v-for="(item, index) in seletedChooseExport"
              :key="item.id"
              :class="index ? 'mg-top15' : ''"
              class="f-csp f-df f-jcsb f-ai">
              <span>{{ item.name }}</span>
              <i
                v-if="!item.isRequired"
                class="el-icon-close"
                @click="deleteSeleted(item, index)">
              </i>
            </dd>
          </dl>
        </div>
      </div>
      <div class="f-df f-jcsb f-ai pd15">
        <el-checkbox v-model="isAllCheck" @change="allCheckChange">
          全选
        </el-checkbox>
        <div class="group-btn f-df f-fdrr">
          <button class="color-white bg-blue bor-blue mg-left15" @click.stop="ensure">确定</button>
          <button class="bg-white bor-gray" @click.stop="cancle">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'isShowExportPopTip', // 默认是value
    event: 'change' // 默认是input事件
  },
  props: {
    isShowExportPopTip: {
      type: Boolean,
      default: false
    },
    exportArr: {
      type: Array,
      default: function() {
        return []
      }
    },
    isExporLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      exportTables: [], // 导出数据的级别
      exportFlats: [], // 导出数据全部拉平
      seletedChooseExport: [], // 已经导出字段选择数据
      isAllCheck: false // 全选
    }
  },
  watch: {
    isShowExportPopTip(val) {
      if (val) {
        this.init()
      } else {
        this.exportTables = []
        this.exportFlats = []
        this.seletedChooseExport = []
      }
    }
  },
  methods: {
    init() {
      this.isAllCheck = false
      this.exportTables = []
      this.exportFlats = []
      this.seletedChooseExport = []
      // 数据拉平一维数组
      this.handFlagData(JSON.parse(JSON.stringify(this.exportArr)), '')
      // 初始化页面导出选择列数：两列
      // 获取一级数据
      const arr = this.exportFlats.filter(item => !item.pId)
      arr[0].active = true
      this.exportTables.push(arr)
      // 获取二级列数
      this.exportItem(arr[0], 0)
      // 初始化已固定选择字段
      this.seletedChooseExport = this.exportFlats.filter(item => item.isCheckBox)
    },
    // 全选
    allCheckChange(val) {
      if (val) {
        this.seletedChooseExport = this.exportFlats.filter(item => {
          item.isCheckBox = true
          return !item.isHasChild
        })
      } else {
        this.seletedChooseExport = this.exportFlats.filter(item => {
          item.isCheckBox = item.isRequired
          return item.isRequired
        })
      }
    },
    // 把所有数据拉平一级
    handFlagData(arr, pId) {
      arr.forEach(item => {
        this.exportFlats.push({
          pId: pId || '',
          id: item.id,
          isHasChild: (item.children && item.children.length),
          name: item.name,
          isCheckBox: item.isCheckBox || false,
          isRequired: item.isRequired || false,
          active: false
        })
        if (item.children && item.children.length) {
          item.children = this.handFlagData(item.children, item.id)
        }
      })
    },
    // 点击可选元素
    exportItem(elem, index) {
      const arr = this.exportFlats.filter(item => {
        if (item.pId === elem.pId) {
          item.active = elem.id === item.id
        }
        return item.pId === elem.id
      })
      if (this.exportTables.length > index + 1) {
        this.$set(this.exportTables, index + 1, arr)
      } else {
        if (arr.length || !index) this.exportTables.push(arr)
      }
    },
    // 选择checkbox
    exportCheckChange(val, item) {
      const index = this.seletedChooseExport.findIndex(selectItem => item.id === selectItem.id)
      if (index < 0 && val) {
        this.seletedChooseExport.push(item)
      }
      if (index >= 0 && !val) {
        this.seletedChooseExport.splice(index, 1)
      }
    },
    // 删除已选择字段
    deleteSeleted(item, index) {
      this.seletedChooseExport.splice(index, 1)
      this.exportFlats.forEach(elem => {
        if (elem.id === item.id) {
          elem.isCheckBox = false
          elem.active = false
        }
      })
    },
    // 确定导出
    ensure() {
      if (!this.seletedChooseExport.length) {
        this.cancle()
        return
      }
      this.$emit('exportEnsure', this.seletedChooseExport)
    },
    // 取消
    cancle() {
      this.$emit('exportCancle')
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.popTip{
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.2);
  & .popTip-box{
    min-width: 700px;
    min-height: 500px;
    border-radius: 3px;
    & .popTip-main-con{
      height: 395px;
    }
    & ul{
      & li.active{background-color: #F2F8FF;}
    }
    & .yxExport-box{
      & dl{
        max-height: calc(100% - 32px);
      }
    }
    & .group-btn button{
      padding: 6px 15px;
      border-radius: 3px;
    }
  }
}
</style>
